import { Link } from 'react-router';

export function ForbiddenState({ message }: { message?: string }) {
  return (
    <section className="forbidden-state" aria-labelledby="forbidden-title">
      <h1 id="forbidden-title" className="page-title">
        Acesso negado
      </h1>
      <p>{message ?? 'Você não tem permissão para acessar esta página.'}</p>
      <Link className="btn btn--secondary" to="/">
        Voltar ao início
      </Link>
    </section>
  );
}
